import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { useLang } from "../contexts/LangContext";

const HERO = "https://images.pexels.com/photos/36430249/pexels-photo-36430249.jpeg";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`${t("account.welcome")}, ${u.name}`);
      if (u.role === "super_admin") nav("/admin");
      else if (u.is_vendor) nav("/azienda");
      else if (u.role === "buyer" || u.role === "admin_broker") nav("/b2b/dashboard");
      else nav(from);
    } catch (e) { toast.error(e.response?.data?.detail || t("ui.error_generic")); } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="grid md:grid-cols-2 min-h-[calc(100vh-5rem)]">
      <div className="hidden md:block relative overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/30 to-transparent" />
        <div className="absolute bottom-10 left-10 text-white">
          <div className="editorial-heading text-4xl">{t("hero.title")}</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-4">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold">{t("nav.login")}</div>
            <h1 className="editorial-heading text-4xl md:text-5xl mt-1">{t("auth.login_title")}</h1>
            <p className="text-sm text-muted-foreground mt-2">{t("auth.login_subtitle")}</p>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider font-semibold">{t("auth.email")}</label>
            <Input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-2" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider font-semibold">{t("auth.password")}</label>
            <Input data-testid="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-2" />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm">
            {loading ? `${t("ui.loading")}` : t("auth.login_btn")}
          </Button>
          <div className="text-sm text-muted-foreground text-center">
            {t("auth.no_account")} <Link to="/register" className="text-[hsl(var(--primary))] underline">{t("auth.register_now")}</Link>
          </div>
          <div className="mt-6 p-3 bg-[hsl(var(--muted))] text-xs rounded-sm space-y-1">
            <div className="font-semibold uppercase tracking-wider">Demo accounts</div>
            <div>admin@terraitalia.com / Admin2026!</div>
            <div>buyer@terraitalia.com / Buyer2026!</div>
            <div>customer@terraitalia.com / Customer2026!</div>
          </div>
        </form>
      </div>
    </div>
  );
}
